<template>
    <div>
        <div class="d-flex align-items-end">
            <h4>Tipos de usuario</h4>
            <div class="flex-grow-1"></div>
            <SettingTypeUser></SettingTypeUser>
        </div>
        <hr>
        <SettingListTypeUser></SettingListTypeUser>

    </div>
</template>
<script>

import SettingListTypeUser from '@/components/UserMaintainer/UserSetting/Setting-list-type-user.vue'
import SettingTypeUser from '@/components/UserMaintainer/UserSetting/Setting-type-user.vue'
export default {
    name: 'UserSetting',
    components: {
        SettingListTypeUser,
        SettingTypeUser,
    }
}
</script>

<style scoped>
h4 {
    margin-bottom: 0;
}
</style>